import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import PlannerResource from '../models/PlannerResource';
import { parseBreaks } from './breakConverters';
import { parseBusinessHours } from './businessHoursConverters';
import { parseCompetences } from './competenceConverters';

const SCHEMA = {
  id: 'resourceId',
  firstName: 'firstName',
  lastName: 'lastName',
  avatar: 'avatar',
  initials: 'initials',
  businessHours: (item: any) => parseBusinessHours(item.businessHours),
  competences: (item: any) => parseCompetences(item.competences),
  breaks: (item: any) => parseBreaks(item.breaks),
};

export function parsePlannerResource(data: any): PlannerResource | null {
  return parseEntity(data, SCHEMA, PlannerResource);
}

export function parsePlannerResources(data: any): Array<PlannerResource> {
  return parseEntities(data, parsePlannerResource);
}